import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/Navbar.css';
import logo from '../../assets/images/MagunexLogo.jpeg'; // Import the logo
import { CompanyContext } from '../../context/CompanyContext';


const Navbar = () => {
     const {companyInfo} =useContext(CompanyContext)
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <img src={logo} alt="MAGUNEX Logo" className="logo-image" />
          <span className="logo-text">{companyInfo.companyNameEng}</span>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/company-dashboard">Home</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/about">About Us</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/support">Support</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pricing">Pricing</Link>
            </li> */}
          </ul>
          <div className="d-flex">
            <Link to="/company-dashboard/branch-login" className="btn btn-primary me-2">Login</Link>
            <Link to="/branch-login" className="btn btn-secondary">Sign Up</Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
